function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Ellipse, G, Path } from "react-native-svg";
/**
 * A fingerprint graphic with customizable color
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-85}
 */ export var Fingerprint = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: 80,
        height: 80,
        viewBox: "0 0 80 80"
    }, props), {
        children: /*#__PURE__*/ _jsx(G, {
            stroke: "none",
            strokeWidth: 1,
            fill: "none",
            fillRule: "evenodd",
            vectorEffect: "non-scaling-stroke",
            children: /*#__PURE__*/ _jsx(G, {
                transform: "translate(-148.000000, -378.000000)",
                children: /*#__PURE__*/ _jsxs(G, {
                    transform: "translate(148.000000, 378.000000)",
                    children: [
                        /*#__PURE__*/ _jsx(Ellipse, {
                            fill: props.color,
                            cx: 40,
                            cy: 40,
                            rx: 40,
                            ry: 39.52
                        }),
                        /*#__PURE__*/ _jsx(G, {
                            transform: "translate(10.602410, 13.012048)",
                            stroke: "#FFF",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: /*#__PURE__*/ _jsxs(G, {
                                transform: "translate(5.923695, 4.738956)",
                                children: [
                                    /*#__PURE__*/ _jsx(Path, {
                                        d: "M35.54 40.28v-8.3a13.03 13.03 0 0 0-26.06 0v7.12",
                                        strokeWidth: 2,
                                        fillRule: "nonzero",
                                        vectorEffect: "non-scaling-stroke"
                                    }),
                                    /*#__PURE__*/ _jsx(Path, {
                                        d: "M45.25 10.64A29.6 29.6 0 0 0 22.5 0a29.5 29.5 0 0 0-22 9.79",
                                        strokeWidth: 2,
                                        fillRule: "nonzero",
                                        vectorEffect: "non-scaling-stroke"
                                    }),
                                    /*#__PURE__*/ _jsx(Path, {
                                        d: "M43.84 30.8c0-9.03-5.62-16.76-13.56-19.86m-7.77-1.46A21.33 21.33 0 0 0 1.18 30.8",
                                        strokeWidth: 2,
                                        fillRule: "nonzero",
                                        vectorEffect: "non-scaling-stroke"
                                    }),
                                    /*#__PURE__*/ _jsx(Path, {
                                        d: "M26.06 42.54V32a3.55 3.55 0 1 0-7.1 0s.2 4.66 0 6.96c-.49 5.68-3.56 8.44-3.56 8.44",
                                        strokeWidth: 2,
                                        fillRule: "nonzero",
                                        vectorEffect: "non-scaling-stroke"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    }));
};
